import script from "./cardHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./cardHistory.vue?vue&type=script&setup=true&lang=js"

import "./cardHistory.vue?vue&type=style&index=0&id=3ccaa31d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccaa31d"]])

export default __exports__